export default __webpack_public_path__ + "static/media/cprofile1.09ca5bc6.png";